export enum ModalitaPaginaGestioneElemento {
  AGGIUNGI,
  MODIFICA,
  DETTAGLIO
}
